/* Catalog search: explicit synonyms, bounded typo tolerance, newest first. */
(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const groups = [
    'vestito vestiti abito abiti dress dresses', 'maglia maglie maglietta magliette tshirt shirt t-shirt',
    'pantalone pantaloni pants trousers', 'gonna gonne skirt skirts', 'giacca giacche jacket jackets',
    'cappotto cappotti coat coats', 'camicia camicie blouse blusa bluse', 'felpa felpe hoodie sweatshirt',
    'coordinato coordinati completo completi set total-look', 'tailleur tailleurs suit suits',
    'tuta tute jumpsuit jumpsuits', 'jeans denim', 'short shorts bermuda pantaloncino pantaloncini',
    'cardigan golfino golfini', 'maglione maglioni pullover sweater', 'canotta canotte tank',
    'nero nera neri nere black', 'bianco bianca bianchi bianche white', 'rosso rossa rossi rosse red',
    'blu blue', 'verde verdi green', 'marrone marroni brown cioccolato chocolate',
    'rosa pink', 'grigio grigia grigi grigie grey gray', 'beige sabbia', 'bordeaux burgundy',
    'viola violet purple', 'giallo gialla gialli gialle yellow', 'arancione arancio orange',
    'azzurro azzurra azzurri azzurre celeste', 'pizzo merletto lace', 'righe rigato rigata striped',
    'leopardato leopardata animalier', 'paillette paillettes sequins', 'oversize oversized',
    'aderente aderenti slim', 'elegante eleganti', 'lungo lunga lunghi lunghe', 'corto corta corti corte'
  ];
  const aliases = new Map();
  groups.forEach(group => {const words = group.split(' '); words.forEach(word => aliases.set(word, words[0]));});
  const stop = new Set('da di del della delle dei degli a al alla alle ai con e in il la le i lo gli un una per donna donne'.split(' '));
  const tokens = value => normalize(value).replace(/t shirt/g, 'tshirt').replace(/total look/g, 'coordinato').split(' ').filter(t => t && !stop.has(t));
  const canonical = word => aliases.get(word) || word;
  function near(a, b) {
    const max = a.length >= 7 ? 2 : a.length >= 4 ? 1 : 0;
    if (!max || Math.abs(a.length - b.length) > max || a[0] !== b[0] && a.length < 5) return false;
    const rows = [Array.from({length:b.length+1}, (_,i)=>i)];
    for (let i=1;i<=a.length;i++) {
      const row=[i];
      for(let j=1;j<=b.length;j++) {
        row[j]=Math.min(row[j-1]+1,rows[i-1][j]+1,rows[i-1][j-1]+(a[i-1]===b[j-1]?0:1));
        if(i>1&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1])row[j]=Math.min(row[j],rows[i-2][j-2]+1);
      }
      rows.push(row);
    }
    return rows[a.length][b.length]<=max;
  }
  function create(products) {
    const ordered=[...products].sort((a,b)=>Number(b.created)-Number(a.created)||Number(b.id)-Number(a.id));
    const entries=ordered.map(product=>({product, words:new Set(tokens([product.title,product.productType,...(product.tags||[])].join(' ')).map(canonical))}));
    const vocabulary=[...new Set(entries.flatMap(e=>[...e.words]))];
    return query => {
      const terms=tokens(String(query).slice(0,160)).slice(0,12);
      if(!terms.length)return terms.length===0&&normalize(query)?[]:ordered;
      const matches=terms.map(raw=>{
        const term=canonical(raw),set=new Set([term]);
        for(const word of vocabulary)if(term.length>=2&&word.startsWith(term)||near(term,word))set.add(word);
        for(const [alias,target] of aliases)if(near(raw,alias))set.add(target);
        return set;
      });
      return entries.filter(e=>matches.every(set=>[...set].some(word=>e.words.has(word)))).map(e=>e.product);
    };
  }
  globalThis.GlowSearch={create};
})();
